import { createFileRoute } from "@tanstack/react-router";
import { CompletedApplicationContent } from "~/components/application/completed-application-content";

export const Route = createFileRoute("/$tenantSlug/completed-application")({
  component: CompletedApplicationContent,
});
